import React, { useEffect, useState } from "react";
import check from "../../assets/images/ic_check.png";
import uncheck from "../../assets/images/ic_uncheck.png";

const CheckBox = ({
    type,
    defaultChecked,
    onChange = () => { }
}) => {

    const Input = {
        width: "6vw",
        height: "4vh",
        cursor: "pointer",
    };

    return (
        <input style={Input}
            onChange={(e) => {
                onChange(e);
            }}
            type={type}
            defaultChecked={defaultChecked}
        />
    );
};

export default CheckBox;